import React, { useState } from 'react';

const UserWiseSwitching = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedUserType, setSelectedUserType] = useState('all');
  
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      userId: 'USR001',
      userName: 'Rajesh Kumar',
      userType: 'Retailer',
      operator: 'Airtel',
      apiProvider: 'API Provider 1',
      priority: 1,
      status: 'Active',
      lastUpdated: '2025-11-05 10:30 AM'
    },
    {
      id: 2,
      userId: 'USR002',
      userName: 'Priya Sharma',
      userType: 'Distributor',
      operator: 'Vodafone',
      apiProvider: 'API Provider 2',
      priority: 2,
      status: 'Active',
      lastUpdated: '2025-11-05 09:15 AM'
    },
    {
      id: 3,
      userId: 'USR003',
      userName: 'Amit Patel',
      userType: 'Retailer',
      operator: 'Jio',
      apiProvider: 'API Provider 1',
      priority: 1,
      status: 'Active',
      lastUpdated: '2025-11-05 08:45 AM'
    },
    {
      id: 4,
      userId: 'USR004',
      userName: 'Sunita Verma',
      userType: 'Master Distributor',
      operator: 'BSNL',
      apiProvider: 'API Provider 3',
      priority: 3,
      status: 'Inactive',
      lastUpdated: '2025-11-04 05:20 PM'
    }
  ]);

  const userTypes = ['all', 'Retailer', 'Distributor', 'Master Distributor', 'Super Distributor'];

  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.userId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.operator.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesUserType = selectedUserType === 'all' || item.userType === selectedUserType;
    
    return matchesSearch && matchesUserType;
  });

  const handleStatusToggle = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
        : item
    ));
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">UserWise Switching</h2>
          <p className="text-muted mb-0">Manage switching configuration for individual users</p>
        </div>
        <button className="btn btn-primary">
          <i className="bi bi-plus-circle me-2"></i>
          Add User Configuration
        </button>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by user name, ID, or operator..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Filter by User Type</label>
              <select
                className="form-select"
                value={selectedUserType}
                onChange={(e) => setSelectedUserType(e.target.value)}
              >
                {userTypes.map((type, index) => (
                  <option key={index} value={type}>
                    {type === 'all' ? 'All User Types' : type}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-primary text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Users</h6>
                  <h3 className="mb-0">{switchingData.length}</h3>
                </div>
                <i className="bi bi-people-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Active</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Active').length}
                  </h3>
                </div>
                <i className="bi bi-check-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Inactive</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Inactive').length}
                  </h3>
                </div>
                <i className="bi bi-x-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Retailers</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.userType === 'Retailer').length}
                  </h3>
                </div>
                <i className="bi bi-person-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>User ID</th>
                  <th>User Name</th>
                  <th>User Type</th>
                  <th>Operator</th>
                  <th>API Provider</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Last Updated</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <span className="badge bg-secondary">{item.userId}</span>
                      </td>
                      <td>
                        <i className="bi bi-person-circle text-primary me-2"></i>
                        {item.userName}
                      </td>
                      <td>
                        <span className="badge bg-info">{item.userType}</span>
                      </td>
                      <td>{item.operator}</td>
                      <td>{item.apiProvider}</td>
                      <td>
                        <span className={`badge ${
                          item.priority === 1 ? 'bg-success' :
                          item.priority === 2 ? 'bg-warning' :
                          'bg-secondary'
                        }`}>
                          Priority {item.priority}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${
                          item.status === 'Active' ? 'bg-success' : 'bg-danger'
                        }`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">{item.lastUpdated}</small>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button className="btn btn-outline-primary" title="Edit">
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button 
                            className={`btn ${
                              item.status === 'Active' ? 'btn-outline-danger' : 'btn-outline-success'
                            }`}
                            onClick={() => handleStatusToggle(item.id)}
                            title={item.status === 'Active' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`bi ${
                              item.status === 'Active' ? 'bi-toggle-on' : 'bi-toggle-off'
                            }`}></i>
                          </button>
                          <button className="btn btn-outline-danger" title="Delete">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      <p className="text-muted mb-0">No user configurations found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} users
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserWiseSwitching;

